"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationModal = void 0;
const button_1 = require("client/components/material/button");
const store_1 = require("client/modules/store/store");
const mobx_1 = require("mobx");
const React = require("react");
const react_1 = require("react");
require("./confirmation-modal.less");
const store_2 = require("../../modules/inventory/modules/inventory-list/store"); //C-046.10
const core_1 = require("@material-ui/core"); //C-046.10
class ConfirmationModal extends react_1.Component {
    constructor() {
        super(...arguments);
        // C-046.11
        this.unresolvedStyles = {
            display: 'flex', flexDirection: 'column',
            fontWeight: 700,
            height: this.props.isError !== undefined && 200,
            overflowY: this.props.isError !== undefined && 'scroll',
        };
        // C-046.11
        this.renderUnresolvedOrders = () => {
            const { unresolved } = this.props;
            const { inventory: { value = [] } } = store_2.inventoryListStore;
            return (React.createElement("div", { style: this.unresolvedStyles }, unresolved === null || unresolved === void 0 ? void 0 : unresolved.map((order) => (React.createElement("a", { style: { color: 'blue' }, target: '_blank', href: `/claims/${order}` }, order)))));
        };
        this.handleCancelClick = () => {
            this.props.onCancel();
        };
        this.handleConfirmClick = () => {
            this.props.onConfirm();
        };
    }
    renderMessage(content) {
        // return <span dangerouslySetInnerHTML={{ __html: content }} />;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { dangerouslySetInnerHTML: { __html: content }, style: { color: this.props.isError ? "#ff5500" : "null" } }),
            this.props.pendingOrders,
            this.props.activeInventories,
            this.props.currentInventories,
            this.props.pendingApprovalOrder));
    }
    // Method will create a list of medications to be displayed in the confirmation Modal
    renderSelectedClaims(claimsArray) {
        return claimsArray.map((claim) => (React.createElement("li", { key: claim.inventory.package },
            claim.inventory.name,
            " -",
            " ",
            claim.inventory.package || claim.inventory.ndc)));
    }
    medicationsSelected(claimsArray) {
        return claimsArray.length > 0
            ? "Medications Selected: "
            : "No Medications Selected";
    }
    render() {
        const { title, confirmText = "", cancelText = "", message, isCancelPrimary = false, shouldDisableConfirm = false, selectedClaims = [], groupItems = [], claimsModal = false, priorityModal = false, addinModal = null, desc, } = this.props;
        let btnEnable = this.props.isSubmit ? true : false; // C-046.205 // lavk2
        const classAdjust = () => store_1.generalStore.menuOpen ? "modal-body modal-body--fix" : "modal-body";
        mobx_1.observe(store_1.generalStore, change => {
            this.handleCancelClick();
        });
        return (React.createElement("div", { className: "confirmation-modal" },
            React.createElement("div", { className: "modal-background", onClick: this.handleCancelClick }),
            React.createElement("div", { className: classAdjust() },
                React.createElement("div", { className: "modal-title" },
                    title,
                    desc && React.createElement(core_1.Typography, { variant: "subheading" }, desc)),
                React.createElement("div", { className: `modal-message${claimsModal ? " modal-message--small" : ""}` },
                    this.props.redirect ? this.props.redirect : null,
                    this.renderMessage(message),
                    this.props.reasonTextField && this.props.reasonTextField,
                    claimsModal ? (React.createElement("div", { className: "modal-medications" },
                        React.createElement("h4", null,
                            this.medicationsSelected(selectedClaims),
                            selectedClaims.length > 0 && (React.createElement("span", null,
                                " (",
                                selectedClaims.length,
                                ")"))),
                        selectedClaims.length > 0 && (React.createElement("ul", null,
                            React.createElement("div", { className: "modal-medications--scroll" }, this.renderSelectedClaims(selectedClaims)))))) : null,
                    addinModal && React.createElement("div", { className: "modal-addin" }, addinModal)),
                priorityModal && (React.createElement("div", { className: "modal-medications" }, groupItems)),
                React.createElement("div", { className: "modal-button-group" },
                    isCancelPrimary !== true && (React.createElement(button_1.MaterialButton, { primary: true, className: "modal-button", onClick: this.handleConfirmClick, disabled: this.props.shouldDisableConfirm
                            ? this.props.shouldDisableConfirm
                            : false }, confirmText)),
                    !btnEnable && isCancelPrimary !== true && (React.createElement(button_1.MaterialButton, { className: "modal-button button-non-primary", onClick: this.handleCancelClick }, cancelText)),
                    isCancelPrimary === true && (React.createElement(button_1.MaterialButton, { primary: true, className: "modal-button", onClick: this.handleCancelClick }, cancelText)),
                    isCancelPrimary === true && (React.createElement(button_1.MaterialButton, { className: "modal-button button-non-primary", onClick: this.handleConfirmClick, disabled: this.props.shouldDisableConfirm
                            ? this.props.shouldDisableConfirm
                            : false }, confirmText))))));
    }
}
exports.ConfirmationModal = ConfirmationModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/confirmation-modal/confirmation-modal.tsx
// module id = 3173
// module chunks = 0